/**
 * Strips HTML tags and decodes entities, for showing rich-text content (authored via
 * RichTextEditor) as a plain-text preview snippet - e.g. in an admin list table row,
 * where dumping the raw HTML string would show literal tags like <div><b><u>...
 */
export const stripHtml = (html) => {
  const raw = String(html ?? '');
  if (!raw.includes('<')) return raw;
  const el = document.createElement('div');
  el.innerHTML = raw;
  return el.textContent || '';
};
